import * as React from "react";
import { FC, useState, useEffect, Fragment } from 'react';
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import {Adsense} from '@ctrl/react-adsense';

interface Props {}

export const GoogleAdsSense: FC<Props> = () => {
  const { location, push } = useHistory();
  const {
    DeviceID,
    ap,
    band,
    campaign,
    search,
    survey_ids,
    token,
    threshold,
    userData,
    skip_seconds,
    each_seconds,
    bc_seconds,
    gads_seconds
  } = location;
  let inter = null;
  const [count, setCount] = useState(gads_seconds ? gads_seconds : 10);
  let countLocal = gads_seconds ? gads_seconds : 10;
  useEffect(() => {
    setCounter();
    return () => {
      clearInterval(inter);
    };
  }, []);

  const setCounter = () => {
    inter = setInterval(() => {
      countLocal = countLocal - 1;
      setCount(countLocal);
      if (countLocal === 0) {
        push("/newdescription", {
          DeviceID,
          ap,
          band,
          campaign,
          search,
          survey_ids,
          token,
          threshold,
          userData,
          skip_seconds,
          each_seconds,
          bc_seconds,
        });
        clearInterval(inter);
      }
    }, 1000);
  };

  return (
    <Fragment>
   {/*    <Adsense
        client="ca-pub-5955866242050454"
        slot="4525363945"
        style={{ display: "block" }}
        format="auto"
        responsive="true"
        data-adtest="on"
      /> */}
    {/*   <ins className="adsbygoogle"
     style={{ display: "block" }}
     data-adtest="on"
     data-ad-client="ca-pub-5955866242050454"
     data-ad-slot="4525363945"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins> */}
    </Fragment>
  );
};
